var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner'),_vm._v(" "),_c('div',{staticClass:"absolutecont"},[_c('div',{staticClass:"web"},[_c('div',{staticClass:"commonbg"},[_c('tab',{attrs:{"cur":"/honor2"}}),_vm._v(" "),_c('div',{staticClass:"mainbody",staticStyle:{"text-align":"center"}},[_c('success-list',{attrs:{"data":_vm.list,"title":"计算机软件著作权登记证书"}})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a5c75ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/honor/honor2.vue
// module id = null
// module chunks = 